<section class="bfa-component-wrapper" *ngIf="data.success">
	<section class="section-separator"></section>
	<h3 class="title-main" dcrHTMLKey="FEES_TITLE" data-cy="fees-title">Fees</h3>
	<section class="ac-dropdown" *ngIf="data?.portfolioData?.length > 1">
		<label dcrHTMLKey="FEES_SELECT_PORTFOLIO">Select Portfolio</label>
		<select (change)="selectPortfolioToView($event.target.value)">
			<option *ngFor="let portfolio of validPortfolioData; index as i" [value]="i">
				<ng-container *ngIf="mode === 'rebalance' && (i === 0 || i === 1)">
					<section [innerHTML]="holdingsAsOfDateData[0].cells[0][i].formattedValue | portfolioDisplayNameRebal : portfolio"></section>
				</ng-container>
				<ng-container *ngIf="mode !== 'rebalance' || i > 1">
					<section *ngFor="let cell of portfolio">
						<section *ngIf="cell?.config.visible && cell?.config.id === 'name'">{{ cell.formattedValue }}</section>
					</section>
				</ng-container>
			</option>
		</select>
	</section>
	<section>
		<perf-fees-overview *ngIf="overviewData; else feesFromComponent" [data]="overviewData" [selectedPortfolioIndex]="selectedPortfolioIndex"></perf-fees-overview>

		<ng-template #feesFromComponent>
			<perf-fees-overview *componentId="'performance.fees.overview'; let res" [data]="res" [selectedPortfolioIndex]="selectedPortfolioIndex"></perf-fees-overview>
		</ng-template>
	</section>
	<section class="margin-standard" *ngIf="data.tabs && data.tabs.length">
		<ng-container *ngFor="let tableData of data.tabs[0].tableData; index as i">
			<data-table
				*ngIf="i === selectedPortfolioIndex"
				[tableData]="tableData"
				[sortable]="true"
				[filter]="filterTerm"
				[searchFormControl]="searchFormControl"
				[defaultPageSize]="defaultPageSize"
				[showPagination]="showPagination"
				[renderPSView]="true"
				[defaultSortKey]="defaultSortKey"
			></data-table>
		</ng-container>
	</section>
	<ng-template #notApplicable> <i class="not-applicable">n/a</i> </ng-template>
	<ac-disclosure [isExpandable]="isDisclosureExpandable">
		<ac-tpm-disclosure></ac-tpm-disclosure>
		<span dcrHTMLKey="FUND_FEE_DISCLAIMER">Fees are as of current prospectus. Source: Morningstar</span>
	</ac-disclosure>
</section>
